// extracted by mini-css-extract-plugin
module.exports = {"main":"Alert_main__K2FqC","mainClickable":"Alert_mainClickable__zbQdU","IconDiv":"Alert_IconDiv__XDHk0","message":"Alert_message__NeAd3","button":"Alert_button__uiCOQ"};